import React from "react";
import PropTypes from "prop-types";
const BookmarkIcon = ({
  noPointer,
  className,
  width,
  size,
  height,
  style,
  color,
  title
}) => (
  <svg
    className={className}
    style={style}
    data-no-pointer={noPointer}
    width={width || size || 24}
    height={height || size || 24}
    viewBox="0 0 14 18"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby="title"
    fill={color || "var(--color-easil-gray-x-dark)"}
  >
    <title>{title}</title>
    <g fill="none" fillRule="evenodd">
      <path d="M-5-3h24v24H-5z" />
      <path d="M-3-1h20v20H-3z" />
      <path
        fill={color || "var(--color-easil-gray-x-dark)"}
        fillRule="nonzero"
        d="M3 2a1 1 0 0 0-1 1v12.778l3.752-3.67a2.003 2.003 0 0 1 2.837.04L12 15.68V3a1 1 0 0 0-1-1H3zm0-2h8a3 3 0 0 1 3 3v12.68a2 2 0 0 1-3.439 1.39l-3.41-3.533-3.752 3.67A2 2 0 0 1 0 15.777V3a3 3 0 0 1 3-3z"
      />
    </g>
  </svg>
);
BookmarkIcon.propTypes = {
  className: PropTypes.string,
  width: PropTypes.string,
  size: PropTypes.string,
  height: PropTypes.string,
  style: PropTypes.object,
  color: PropTypes.string
};

export default BookmarkIcon;
